import { supabaseCirculoAnimal } from '../config/settings/supabase-client'
import factoryService from '../core/requests-supabase/services'

const rowsToConfig = (rows = []) =>
  rows.reduce((config, row) => {
    if (row?.key) {
      config[row.key] = row.value
    }

    return config
  }, {})

/**
 * Gets all config keys for the given app.
 * app_config rows: { app_key, key, value }
 */
export const getAppConfig = factoryService(async ({ app }) => {
  const { data, error } = await supabaseCirculoAnimal
    .from('app_config')
    .select('key, value')
    .eq('app_key', app)

  return {
    data: rowsToConfig(data),
    error,
  }
})
